import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LstorageService } from './lstorage.service';
import { BehaviorSubject } from 'rxjs';
import { api_routes } from '../../configs/apiConfig';
import { LSkeys } from '../../configs/app.constants';
import { environment } from '../../../../environments/environment';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ServiceCustomerInfoApiOutputModel, User } from '../../models/api/customer.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  initailLoading = new BehaviorSubject(true)
  private _appBaseUrl: string = "";
  private _apiBaseUrl: string = "";
  private _apiRoutes: typeof api_routes;
  private _theme: HTMLLinkElement;
  private _socketUrl: string = "";
  private _userInfo = new BehaviorSubject<User | null>(null);
  private _stripeKey: string = "";
  private _googleMapApiKey: string = "";
  private _fcmConfig: any = {};
  private _configReady = new BehaviorSubject<boolean>(false);
  configReady$ = this._configReady.asObservable();
  userInfo$ = this._userInfo.asObservable();
  private userImageSource = new BehaviorSubject<string | null>(null);
  userImage$ = this.userImageSource.asObservable();


  constructor(private httpClient: HttpClient, private lsServ: LstorageService, private translate: TranslateService) {
    this._apiRoutes = api_routes;
    this._theme = document.getElementById('app-theme') as HTMLLinkElement
  }

  initApp() {
    this.getAppConfig();
    // this.loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyBWlReLpzQZ4X2qTzoqAJDm3TjpJYJL9m0&libraries=places');
    if (this.lsServ.getItem(LSkeys.THEME)) {
      this._theme.href = this.lsServ.getItem(LSkeys.THEME) + ".css"
    }
    const storedLanguage = this.lsServ.getItem(LSkeys.SELECTED_LANGUAGE);
    if (storedLanguage) {
      this.setLanguage(storedLanguage);
    } else {
      const defaultLanguage = 'en';
      this.lsServ.store(LSkeys.SELECTED_LANGUAGE, defaultLanguage);
      this.setLanguage(defaultLanguage);
    }

    return this.initailLoading
  }

  private getAppConfig() {
    this.httpClient.get<any>(`/assets/${environment.appConfig}`).subscribe(res => {
      this._appBaseUrl = res.appBaseUrl
      this._apiBaseUrl = res.remoteServiceBaseUrl + res.apiBasePath
      this._socketUrl = res.socketUrl;
      this._stripeKey = res.stripKey;
      this._googleMapApiKey = res.googleMapApiKey;
      this._fcmConfig = res.fcm || {};
      this._configReady.next(true);
      this.generateApiUrl();
      this.updateUserInfo();
      this.initailLoading.next(false)
    });
    // setTimeout(() => {
    //   this.loadScript('https://maps.googleapis.com/maps/api/js?key='+this._googleMapApiKey+'&libraries=places');
    // }, 1000);

  }

  private generateApiUrl() {
    Object.keys(this._apiRoutes).forEach(apiUrl => {
      this._apiRoutes[apiUrl as keyof typeof this._apiRoutes] = this._apiBaseUrl + this._apiRoutes[apiUrl as keyof typeof this._apiRoutes]
    });
  }

  public updateUserInfo() {
    const authToken = this.lsServ.getItem(LSkeys.AUTH_TOKEN);
    if (!authToken) {
      return;
    }

    const payload = {
      'category_id': 4,
      'latitude': 0,
      'longitude': 0,
      'distance': 4,
      'access_token': authToken
    };

    this.httpClient.post<ServiceCustomerInfoApiOutputModel>(this._apiRoutes.CUSTOMER_DETAILS, payload)
      .subscribe({
        next: (response) => {
          if (response.success && response.result.data.Details.user) {
            const user = response.result.data.Details.user;
            this.setUserInfo(user);
          } else {
            this.setUserInfo(null);
          }
        },
        error: (error) => {
          this.setUserInfo(null);
        }
      });
  }


  setUserInfo(user: User | null): void {
    this._userInfo.next(user);
    if (user && user.profile_image) {
      const profileImageUrl = user.profile_image.startsWith('http')
        ? encodeURI(`${user.profile_image}?t=${new Date().getTime()}`)
        : encodeURI(`https://bringitnow.s3.amazonaws.com/Uploads/${user.profile_image}?t=${new Date().getTime()}`);
      setTimeout(() => {
        this.userImageSource.next(profileImageUrl);
      }, 1000);
    } else {
      this.userImageSource.next(null);
    }
  }

  get appBaseUrl() {
    return this._appBaseUrl
  }
  get apiBaseUrl() {
    return this._apiBaseUrl
  }
  get apiRoutes() {
    return this._apiRoutes
  }

  get themeDark() {
    return this.lsServ.getItem(LSkeys.THEME) == "dark"
  }

  get socketBaseUrl() {
    return this._socketUrl
  }

  get stripeKey() {
    return this._stripeKey;
  }

  get googleMapApiKey() {
    return this._googleMapApiKey;
  }

  get fcmConfig() {
    return this._fcmConfig;
  }

  public noWhiteSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value && /^\s/.test(control.value)) {
        return { 'whiteSpace': true };
      }
      return null;
    };
  }
  setLanguage(language: string) {
    this.lsServ.store(LSkeys.SELECTED_LANGUAGE, language);
    this.translate.setDefaultLang(language);
    this.translate.use(language);
    if (language === 'ar') {
      document.documentElement.setAttribute('dir', 'rtl');
    } else {
      document.documentElement.setAttribute('dir', 'ltr');
    }
  }

  convertToFormdata(data: any) {
    let formData = new FormData();
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
        formData.append(key, data[key]);
      }
    });
    return formData;
  }

  loadScript(src: string): void {
    const script = document.createElement('script');
    script.src = src;
    // script.async = true;
    // script.defer = true;
    document.head.appendChild(script);
  }

  compressImage(file: File, maxSizeKB: number): Promise<File> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e: any) => {
        img.src = e.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;

        // Start with original dimensions
        let width = img.width;
        let height = img.height;

        // Initial compression quality (start high to preserve readability)
        let quality = 0.9;

        // Helper to generate blob and check size
        const tryCompress = () => {
          canvas.width = width;
          canvas.height = height;
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(blob => {
            if (!blob) return reject('Compression failed.');
            const isUnderLimit = blob.size <= maxSizeKB * 1024;

            if (isUnderLimit || (quality <= 0.3 && width <= 600)) {
              const newFile = new File([blob], file.name, { type: file.type });
              resolve(newFile);
            } else {
              // Gradually reduce quality and size for further compression
              quality -= 0.1;
              width *= 0.9;
              height *= 0.9;
              tryCompress();
            }
          }, file.type || 'image/jpeg', quality);
        };

        tryCompress();
      };

      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }

}
